import { render, staticRenderFns } from "./FlowForm.vue?vue&type=template&id=5479f08e&"
import script from "./FlowForm.vue?vue&type=script&lang=js&"
export * from "./FlowForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports